import {Component, Input, OnInit} from '@angular/core';
import * as moment from 'moment';
import {NbDialogService} from '@nebular/theme';
import {CreatePaymentReferenceComponent} from './create-payment-reference/create-payment-reference.component';
import {HistoryPaymentReferenceComponent} from './history-payment-reference/history-payment-reference.component';

@Component({
  selector: 'ngx-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
})
export class PaymentComponent implements OnInit {
  @Input() stations: any;
  initDurationTime = 1;
  maxMonthPayStore = 1;
  moment = moment;
  constructor(
    private dialogService: NbDialogService,
  ) { }

  ngOnInit() {
    this.stations.forEach(station => {
      station.durationTime = this.initDurationTime;
      station.endPlan = moment().format('LL');
    });
  }

  async generateRefence(station: any, type: number) {
    this.dialogService.open(CreatePaymentReferenceComponent, {
      hasScroll: true,
      context: { station, type },
    });
  }

  async getHistory(station: any) {
    this.dialogService.open(HistoryPaymentReferenceComponent, {
      hasScroll: true,
      context: { station },
    });
  }
}
